module.exports = __webpack_public_path__ + "img/on-proses-dm.27a3fef6.svg";